import React from 'react';
import cx from 'classnames';
import Lottie from 'lottie-react';
import styles from './index.module.scss.js';
import animationData from '../../../../../animations/lottie/check.json.js';

const AnimationWrapper = () => /* @__PURE__ */ React.createElement("div", { className: cx(styles.box) }, /* @__PURE__ */ React.createElement(
  Lottie,
  {
    animationData,
    autoPlay: true,
    loop: false,
    height: 120,
    width: 120
  }
), " ");
AnimationWrapper.displayName = "Auth.Form.AnimationWrapper";

export { AnimationWrapper };
//# sourceMappingURL=index.js.map
